//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import VideoLibraryResultsItemDialog from "./Dialog.vue";
export default {
    name: "VideoLibraryResultsItem",
    props: ["result", "formatDate", "openInNewWindow","searchSubmitted", "showPlaylist"],
    components: {VideoLibraryResultsItemDialog },
    computed: {
        date() {
            return this.formatDate(this.result.itemDate, "MMM dd, yyyy");
        },
        playlistLength() {
            return this.result.meta.playlists?.length || this.result.videos?.length;
        },
        isPlaylist() {
            return this.result.meta.type === "PlayList";
        },
        shortDescription() {
            return this.result.meta?.shortDescription || "";
        }
    },
    data () {
        return {
            dialogOpen: false,
            showPlaylists: false
        }
    },
    methods: {
        openDialog() {
            this.dialogOpen = true
        },
        togglePlaylists() {
            this.showPlaylists = !this.showPlaylists;
        }
    }
};
